import type { RouteRecordRaw } from "vue-router";
import { FeatureFlagName } from "@/services/fyApi";
import { routes as eventEditRoutes } from "@/frontend/pages/fleets/[slug]/events/[event]/edit/routes";

export const routes: RouteRecordRaw[] = [
  {
    path: "",
    name: "fleet-events",
    component: () => import("@/frontend/pages/fleets/[slug]/events/index.vue"),
    meta: {
      mobileBack: true,
      backgroundImage: "bg-8",
      title: "fleets.events.index",
      needsAuthentication: true,
      access: ["fleet:events:read", "fleet:events:manage", "fleet:manage"],
      customTitle: true,
    },
  },
  {
    path: "new/",
    name: "fleet-event-new",
    component: () => import("@/frontend/pages/fleets/[slug]/events/new.vue"),
    meta: {
      backgroundImage: "bg-8",
      title: "fleets.events.create",
      needsAuthentication: true,
      access: ["fleet:events:create", "fleet:events:manage", "fleet:manage"],
      customTitle: true,
    },
  },
  {
    path: ":event/edit/",
    component: () =>
      import("@/frontend/pages/fleets/[slug]/events/[event]/edit.vue"),
    children: eventEditRoutes,
    redirect: { name: eventEditRoutes[0].name as string },
    meta: {
      backgroundImage: "bg-8",
      title: "fleets.events.edit",
      needsAuthentication: true,
      access: ["fleet:events:update", "fleet:events:manage", "fleet:manage"],
      customTitle: true,
    },
  },
  {
    path: ":event/payouts/",
    name: "fleet-event-payouts",
    component: () =>
      import("@/frontend/pages/fleets/[slug]/events/[event]/payouts.vue"),
    meta: {
      backgroundImage: "bg-8",
      title: "fleets.events.payouts",
      needsAuthentication: true,
      // Route meta merges shallowly, so this list replaces the events root's
      // flag rather than adding to it, and has to carry it itself.
      feature: [
        FeatureFlagName.FLEET_MISSION_BUILDER,
        FeatureFlagName.FLEET_TOURS,
      ],
      featureScope: "fleet",
      // Event privileges are in the list because the ledger's own policy lets
      // an event's creator, admins and moderators manage it, and none of that
      // is expressible as a fleet privilege. The API is still the gate; this
      // only decides who may open the page.
      access: [
        "fleet:payouts:read",
        "fleet:payouts:manage",
        "fleet:events:read",
        "fleet:events:manage",
        "fleet:manage",
      ],
      customTitle: true,
    },
  },
  {
    path: ":event/",
    name: "fleet-event",
    component: () =>
      import("@/frontend/pages/fleets/[slug]/events/[event].vue"),
    meta: {
      backgroundImage: "bg-8",
      title: "fleets.events.show",
      needsAuthentication: true,
      access: ["fleet:events:read", "fleet:events:manage", "fleet:manage"],
      customTitle: true,
    },
  },
];
